import { render, staticRenderFns } from "./Size.vue?vue&type=template&id=42528074&scoped=true&"
import script from "./Size.vue?vue&type=script&lang=ts&"
export * from "./Size.vue?vue&type=script&lang=ts&"
import style0 from "./Size.vue?vue&type=style&index=0&id=42528074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42528074",
  null
  
)

export default component.exports